module.exports = __webpack_public_path__ + "img/com15.dbbeefdb.gif";